import { useEffect, useRef, useState } from 'react';
import { useLang } from '../i18n/LanguageContext';
import { useCart } from '../context/CartContext';
import { storefront } from '../lib/supabase';
import { getReply } from '../lib/advisorEngine';
import { formatVND, pickLang } from '../lib/format';

export default function ChatbotWidget() {
  const { lang, t } = useLang();
  const { add } = useCart();
  const [open, setOpen] = useState(false);
  const [catalog, setCatalog] = useState(null);
  const [messages, setMessages] = useState([]); // {from:'bot'|'user', text} | {from:'reco', picks}
  const [options, setOptions] = useState([]);
  const [state, setState] = useState(null);
  const bodyRef = useRef(null);

  useEffect(() => {
    if (!open || catalog) return;
    Promise.all([storefront.products(), storefront.combos()]).then(([p, c]) => {
      const cat = { products: p.data || [], combos: c.data || [] };
      setCatalog(cat);
      const r = getReply(null, null, cat, lang);
      setState(r.state);
      setMessages(r.messages.map((m) => ({ from: 'bot', text: m })));
      setOptions(r.options);
    });
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    bodyRef.current?.scrollTo(0, bodyRef.current.scrollHeight);
  }, [messages, options]);

  const choose = (opt) => {
    if (!catalog) return;
    const next = getReply(state, opt.value, catalog, lang);
    setState(next.state);
    setMessages((prev) => [
      ...(opt.value === 'restart' ? [] : prev),
      ...(opt.value === 'restart' ? [] : [{ from: 'user', text: opt.label }]),
      ...next.messages.map((m) => ({ from: 'bot', text: m })),
      ...(next.recommendations?.length ? [{ from: 'reco', picks: next.recommendations }] : []),
    ]);
    setOptions(next.options || []);
  };

  const addPick = (pick) => {
    const it = pick.item;
    add(
      { kind: pick.kind, id: it.id, name: it.name, name_en: it.name_en, price: pick.price, category: it.category || 'combo' },
      pick.qty || 1
    );
  };

  return (
    <>
      <button className="chat-fab" onClick={() => setOpen(!open)} aria-label={t('chat.open')}>
        {open ? '✕' : '💬'}
      </button>
      {open && (
        <div className="chat-panel">
          <div className="chat-head">
            <span>🎁 {t('chat.title')}</span>
            <button onClick={() => setOpen(false)}>✕</button>
          </div>
          <div className="chat-body" ref={bodyRef}>
            {!catalog && <div className="muted">{t('misc.loading')}</div>}
            {messages.map((m, i) =>
              m.from === 'reco' ? (
                m.picks.map((pick, j) => (
                  <div className="chat-reco" key={`${i}-${j}`}>
                    <div>
                      {pick.kind === 'combo' && <span className="badge badge-sale" style={{ marginRight: 4 }}>COMBO</span>}
                      <strong>{pickLang(pick.item, 'name', lang)}</strong>
                      <div className="muted">{formatVND(pick.price)}{pick.qty > 1 ? ` × ${pick.qty}` : ''}</div>
                    </div>
                    <button className="btn btn-primary btn-sm" onClick={() => addPick(pick)}>+ 🛒</button>
                  </div>
                ))
              ) : (
                <div key={i} className={`chat-msg ${m.from}`}>{m.text}</div>
              )
            )}
          </div>
          <div className="chat-opts">
            {options.map((o) => (
              <button key={o.value} className="chip" onClick={() => choose(o)}>{o.label}</button>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
